<template>
  <div id="maatcomputers">
    <router-view />
  </div>
</template>

<style>
  @import "assets/stylesheets/base.css";
</style>
